import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ModalRef } from '@freelancer/ui';
import { ButtonColor, ButtonSize } from '@freelancer/ui/button';
import { HeadingSize, HeadingType } from '@freelancer/ui/heading';
import { Margin } from '@freelancer/ui/margin';
import { StickyBehaviour, StickyPosition } from '@freelancer/ui/sticky';
import { FontWeight } from '@freelancer/ui/text';
import {
  EntryFilterOption,
  EntrySortOption,
} from '../contest-view/contest-view.component';

@Component({
  template: `
    <fl-bit flTrackingSection="ContestViewPage.AdvancedFiltersModal">
      <fl-heading
        i18n="Advanced filters header"
        [size]="HeadingSize.XSMALL"
        [headingType]="HeadingType.H1"
        [flMarginBottom]="Margin.MID"
      >
        Advanced Filters
      </fl-heading>
      <fl-text
        i18n="View entries text"
        [weight]="FontWeight.BOLD"
        [flMarginBottom]="Margin.XXSMALL"
      >
        View Entries
      </fl-text>
      <fl-select
        flTrackingLabel="SelectFilterOption"
        [control]="entryFilterControl"
        [options]="entryFilterOptions"
        [flMarginBottom]="Margin.MID"
      ></fl-select>
      <fl-text
        i18n="Sort by text"
        [weight]="FontWeight.BOLD"
        [flMarginBottom]="Margin.XXSMALL"
      >
        Sort By
      </fl-text>
      <fl-select
        flTrackingLabel="SelectSortOption"
        [control]="entrySortControl"
        [options]="entrySortOptions"
      ></fl-select>
      <fl-container
        class="EntryAdvancedFilters-cta"
        [flSticky]="true"
        [flStickyBehaviour]="StickyBehaviour.ALWAYS"
        [flStickyPosition]="StickyPosition.BOTTOM"
      >
        <fl-link
          i18n="Reset filters link"
          flTrackingLabel="ClickResetFilters"
          [flMarginBottom]="Margin.LARGE"
          (click)="handleResetFiltersClick()"
        >
          Reset Filters
        </fl-link>
        <fl-button
          i18n="Apply filters button"
          flTrackingLabel="ClickApplyFilters"
          [color]="ButtonColor.SECONDARY"
          [size]="ButtonSize.SMALL"
          [display]="'block'"
          (click)="handleApplyFiltersClick()"
        >
          Apply Filters
        </fl-button>
      </fl-container>
    </fl-bit>
  `,
  styleUrls: ['./entry-advanced-filters-modal.component.scss'],
})
export class EntryAdvancedFiltersModalComponent implements OnInit {
  ButtonColor = ButtonColor;
  ButtonSize = ButtonSize;
  FontWeight = FontWeight;
  HeadingSize = HeadingSize;
  HeadingType = HeadingType;
  Margin = Margin;
  StickyBehaviour = StickyBehaviour;
  StickyPosition = StickyPosition;

  @Input() currentEntryFilterOption: EntryFilterOption;
  @Input() currentEntrySortOption: EntrySortOption;

  entryFilterOptions = Object.values(EntryFilterOption);
  entryFilterControl: FormControl;

  entrySortOptions = Object.values(EntrySortOption);
  entrySortControl: FormControl;

  constructor(private modalRef: ModalRef<EntryAdvancedFiltersModalComponent>) {}

  ngOnInit() {
    this.entryFilterControl = new FormControl(this.currentEntryFilterOption);
    this.entrySortControl = new FormControl(this.currentEntrySortOption);
  }

  handleResetFiltersClick() {
    this.entryFilterControl.setValue(EntryFilterOption.ALL_ENTRIES);
    this.entrySortControl.setValue(EntrySortOption.DEFAULT);
  }

  handleApplyFiltersClick() {
    this.modalRef.close({
      filter: this.entryFilterControl.value,
      sort: this.entrySortControl.value,
    });
  }
}
